import { createContext, useContext, useState, useCallback } from "react";

const FlashCtx = createContext(null);
export const useFlash = () => useContext(FlashCtx);

export function FlashProvider({ children }) {
  const [items, setItems] = useState([]);

  // opts: { action: "Fortryd", onAction: fn, ms: 10000 }
  const flash = useCallback((text, type = "", opts = {}) => {
    if (!text) return;
    const id = Math.random().toString(36).slice(2);
    setItems((prev) => [...prev, { id, text, type, ...opts }]);
    setTimeout(() => setItems((prev) => prev.filter((i) => i.id !== id)), opts.ms || 5000);
  }, []);

  const dismiss = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  return (
    <FlashCtx.Provider value={flash}>
      {children}
      {items.length > 0 && (
        <div className="toast-wrap" data-testid="flash-wrap">
          {items.map((i) => (
            <div key={i.id} className={`notice ${i.type}${i.action ? " has-action" : ""}`} role="status" onClick={() => dismiss(i.id)}>
              <span>{i.text}</span>
              {i.action && (
                <button
                  type="button"
                  className="toast-action"
                  data-testid="flash-action"
                  onClick={(e) => { e.stopPropagation(); dismiss(i.id); i.onAction?.(); }}
                >
                  {i.action}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </FlashCtx.Provider>
  );
}
